<span class="counter" [ngClass]="{'counter-error': total < count}">
  {{count}}/{{total}}
</span>